import {Link, useNavigate} from "react-router-dom";
import {useState} from "react";
import {IoIosArrowDown, IoIosArrowUp} from "react-icons/io";
import SideBarIcon from "../Icon/SideBarIcon";
import {useDrawer} from "../../redux/Reducers/DrawerReducer";
import {useSelector} from "react-redux";


export default function SidebarSubMenu({className, route, ...props}) {
    const [isDropdownMenuOpen, setIsDropdownMenuOpen] = useState(true)
    const {actions} = useDrawer();
    const naviations = useNavigate();
    const languagesSlice = useSelector(state => state.LanguageSlice);

    function handleDropdownMenuClick() {
        setIsDropdownMenuOpen(!isDropdownMenuOpen)
    }

    return (

        <li className="relative px-6 py-3" key={route.name}>

            <div
                className="inline-flex  justify-between w-full text-base font-semibold

                 transition-colors duration-150 hover:text-gray-800 dark:text-gray-100 dark:hover:text-gray-300"
                onClick={handleDropdownMenuClick}

            >
                {route.icon ? <SideBarIcon name={route.icon}/> : null}
                <div className="flex flex-col self-center  flex-1">
                    <div className="w-full inline-flex items-center mb-2 flex-1">
                        <p className="ml-4 cursor-pointer mr-2">{
                            route.translatedNames[languagesSlice.selectedLanguageObject.id] || route.name
                        }</p>
                        {
                            !isDropdownMenuOpen ?
                                <IoIosArrowDown onClick={() => setIsDropdownMenuOpen(!isDropdownMenuOpen)}
                                                className="w-4 h-4 cursor-pointer ml-1 " aria-hidden="true"/> :
                                <IoIosArrowUp onClick={() => setIsDropdownMenuOpen(!isDropdownMenuOpen)}
                                              className="w-4 h-4 cursor-pointer ml-1 " aria-hidden="true"/>
                        }

                    </div>
                    {isDropdownMenuOpen && (
                        <div className={"ml-4 mt-2 gap-2  font-semibold flex flex-col"}>
                            {
                                route.routes.map((subRoute,index) => (
                                    <div
                                        key={index}
                                        onClick={() => {
                                            naviations(subRoute.path)
                                            actions.closeDrawer()
                                        }}

                                        className={"cursor-pointer"}
                                    >
                                        {
                                            subRoute.translatedNames[languagesSlice.selectedLanguageObject.id] || subRoute.name
                                        }
                                    </div>))
                            }
                        </div>
                    )}
                </div>


            </div>

        </li>

    )
}